import { fluidUrlAttributeName } from '@fluidx/office-fluid-types';

/**
 * Puts the given text on the system clipboard
 */
export async function copyText(text: string) {
  copyWithExecCommand(text);
}

/**
 * Puts the given url on the user's clipboard. The format (used to help
 * disambiguate between expected paste behaviors) is to store it in 2 clipboard
 * slots:
 * - In the text slot as simple text
 * - In the html slot as a div which both has the fluid-url attribute with the
 *   url and the url as text inside the div
 *
 * @param url the url to be copied
 */
export function copyComponentUrl(url: string) {
  copyWithExecCommand(url, `<div ${fluidUrlAttributeName}="${url}">${url}</div>`);
}

export function copyWithExecCommand(text?: string, html?: string) {
  const selection = window.getSelection();
  if (!selection) {
    return;
  }

  // Try to store the old selection to restore it
  let oldRange = selection.rangeCount === 1 ? selection.getRangeAt(0) : undefined;

  // Create a place to attach the content
  const div = document.createElement('div');
  div.style.position = 'absolute';
  div.style.opacity = '0';

  // Div cannot be 'hidden'; prevents copy from working
  div.contentEditable = 'true';
  document.body.append(div);

  // Select the content
  selection.removeAllRanges();
  const newRange = new Range();
  newRange.setStart(div, 0);
  newRange.setEnd(div, 0);
  selection.addRange(newRange);

  // We're going to initiate a copy command which will result in a copy event
  // being generated
  div.addEventListener('copy', (ev: ClipboardEvent) => {
    // If the event allows us to access the clipboard, populate it
    if (ev.clipboardData) {
      text && ev.clipboardData.setData('text/plain', text);
      html && ev.clipboardData.setData('text/html', html);
    }

    // Cleanup
    div.remove();
    selection.removeAllRanges();
    if (oldRange) {
      selection.addRange(oldRange);
    }

    ev.preventDefault();
    ev.stopPropagation();
  });

  document.execCommand('copy');
}
